import { NgIf } from '@angular/common';
import { Component, EventEmitter, input, InputSignal, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonComponent } from '../../atoms/button/button.component';

@Component({
  selector: 'app-auth-button',
  templateUrl: './auth-button.component.html',
  imports: [ButtonComponent, NgIf, RouterLink],
})
export class AuthButtonComponent {
  public buttonText: InputSignal<string> = input.required();
  public disabled: InputSignal<boolean> = input(false);
  public hintText: InputSignal<string> = input('');
  public isLoading: InputSignal<boolean> = input(false);
  public linkText: InputSignal<string> = input('');
  public route: InputSignal<string> = input('');
  public showHint: InputSignal<boolean> = input(false);
  public type = input<'button' | 'submit'>('submit');

  @Output() clicked = new EventEmitter<void>();

  public test(): string {
    return 'hallo';
  }
}
